import { ObjectPermissionSetData } from '../types/permissions';

export const findPermissionByName = (permissions: ObjectPermissionSetData[], permissionName: string): ObjectPermissionSetData | undefined =>
 permissions.find((permission) => permission.objectPermission.objectPermissionName === permissionName);

export const findPermissionByModule = (moduleId: number, permissions: ObjectPermissionSetData[]): ObjectPermissionSetData[] | [] => {
 return permissions.filter((permission) => permission.objectId === moduleId) || [];
};

export const findPermission = (
 permissions: ObjectPermissionSetData[],
 filter: { moduleId: number; permissionName: string }
): ObjectPermissionSetData | undefined => {
 const modulePermissions = findPermissionByModule(filter.moduleId, permissions);
 const permission = findPermissionByName(modulePermissions, filter.permissionName);
 return permission;
};
